// https://stackoverflow.com/questions/19491336/how-to-get-url-parameter-using-jquery-or-plain-javascript
function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

$(document).ready(function() {
    // Attach a click event handler to the resend link
    $("#resend_verify_link").click(function(event) {
        event.preventDefault();
        // Check if the link is already disabled
        if ($(this).hasClass("disabled")) {
            return; // Exit if the link is disabled
        }
        // Disable the link to prevent multiple clicks
        $(this).addClass("disabled");

        $('.btn-form-save').prop('disabled', true);
        $('.btn-form-save').html('<i class="fa fa-spinner fa-pulse"></i> Resending');

        var action_url = $(this).data("action");
        var id = $("#report_id").val();
        $.ajax({
            type: 'POST',
            url: action_url,
            headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
            data: {'report_id': id},
            success: function(data) {
                //reset values
                $("#resend_verify_link").removeClass("disabled");
                $('.btn-form-save').prop('disabled', false);
                $('.btn-form-save').html('Continue');
                $('#verify_success_message').text("");
                $('#verify_error_message').text("");
                
                if (data.data.success == true) {
                    $('#verify_success_message').text(data.data.message);
                } else if (data.data.success == false) {
                    $('#verify_error_message').text(data.data.message);
                }
            },
            error:function(xhr, textStatus, errorThrown){
                $.each(xhr.responseJSON, function(k, v){
                    $('#verify_error_message').text(v);
                });
            } 
        });
    });

    /* 4 Digits One-Time-Code Input - https://codepen.io/GeoffreyCrofte/pen/zYrxKRe */
        let in1 = $('#otp-1');
        let ins = $('input[type="number"]');

        // Function to split the input value into individual digits
        function splitNumber(e) {
            // Get the input value
            let data = e.data || e.target.value;
            if (!data) return;
            if (data.length === 1) return;

            // Call the function to populate next input fields
            popuNext($(e.target), data);
        }

        // Recursive function to populate the next input fields
        function popuNext(el, data) {
            // Set the value of the current input field
            el.val(data[0]);
            // Remove the first character from data
            data = data.substring(1);
            // If there's a next input element and data is still available
            if (el.next().length && data.length) {
                // Recursively call popuNext for the next element
                popuNext(el.next(), data);
            }
        }

        // Loop through each input element
        ins.each(function() {
            $(this).on('keyup', function(e) {
                // If Shift, Tab, CMD, Option, Control key is pressed
                if ( e.keyCode === 16 || e.keyCode == 9 || e.keyCode == 224 || e.keyCode == 18 || e.keyCode == 17 ) {
                    // Exit the function
                    return;
                }
                // If Backspace or Left arrow key is pressed and there's a previous input element
                if ( (e.keyCode === 8 || e.keyCode === 37) && this.previousElementSibling && this.previousElementSibling.tagName === 'INPUT' ) {
                    // Select the previous input element
                    this.previousElementSibling.select();
                } 
                // If a key other than Backspace is pressed and there's a next input element
                else if (e.keyCode !== 8 && this.nextElementSibling) {
                    // Select the next input element
                    this.nextElementSibling.select();
                }
                // If the current input value's length is greater than 1
                if ($(e.target).val().length > 1) {
                    splitNumber(e);
                }
            });

            $(this).on('focus', function(e) {
                // If the focused element is the first one, return
                if ($(this)[0] === in1[0]) return;

                // If the first input is empty, focus on it
                if (in1.val() == '') {
                    in1.focus();
                }
                // If the previous input is empty, focus on it
                if ($(this).prev().val() == '') {
                    $(this).prev().focus();
                }
            });
        });
        in1.on('input', splitNumber);
    /* https://codepen.io/GeoffreyCrofte/pen/zYrxKRe */

    /* Countdown Timer - https://codepen.io/luci/pen/EEavVR*/
        // Set the time limit in minutes
        var timeLimitInMinutes = 1;

        // Convert the time limit to seconds
        var timeLimitInSeconds = timeLimitInMinutes * 60;
        var timerElement = document.getElementById('timer');

        var resendLinkElement = document.getElementById('resend_verify_link');
        var timerInterval;

        function startTimer() {
            timeLimitInSeconds--;

            // Disable the anchor tag if less than 1 minute is left
            if (timeLimitInSeconds <= 60) {
                resendLinkElement.classList.add('disabled');
            } else {
                resendLinkElement.classList.remove('disabled');
            }

            var minutes = Math.floor(timeLimitInSeconds / 60);
            var seconds = timeLimitInSeconds % 60;

            if (timeLimitInSeconds < 0) {
                timerElement.textContent = '00:00';
                clearInterval(timerInterval);

                // Remove the 'disabled' class when the timer reaches '00:00'
                resendLinkElement.classList.remove('disabled');

                return;
            }
            // Add leading zero to minutes and seconds if they are less than 10
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            if (seconds < 10) {
                seconds = '0' + seconds;
            }

            timerElement.textContent = minutes + ':' + seconds;
        }

        // Check the 'id' parameter and start the timer
        function checkAndStartTimer() {
            var idParameter = getUrlParameter('id');

            if (idParameter) {
                startTimer(); // Start the timer
            }
        }
        // Call the checkAndStartTimer function every second
        var checkInterval = setInterval(checkAndStartTimer, 1000);

    /*https://codepen.io/luci/pen/EEavVR*/
});
